import { axios } from './axios.js';

export const aiInference = async data => {
  const res = await axios.post('/ai/inference', data);
  return res.data;
};

export const getThreads = async () => {
  const res = await axios.get('/ai/threads');
  return res.data;
};

export const createThread = async data => {
  const res = await axios.post('/ai/thread', data);
  return res.data;
};

export const deleteThread = async id => {
  const res = await axios.delete(`/ai/thread/${id}`);
  return res.data;
};

export const confirmAiAction = async token => {
  const res = await axios.post('/ai/confirm-action', {
    token,
  });
  return res.data;
};

export const getChatBookmarks = async () => {
  const res = await axios.get('/ai/bookmarks');
  return res.data;
};

export const createChatBookmark = async data => {
  const res = await axios.post('/ai/bookmark', data);
  return res.data;
};

export const deleteChatBookmark = async id => {
  const res = await axios.delete(`/ai/bookmark/${id}`);
  return res.data;
};
